import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { SidebarData } from "./SidebarData";
import SubMenu from "./SubMenu";
import { IconContext } from "react-icons/lib";
import "./styles/style.scss";
import Backdrop from "./Backdrop";
import logo from "../../../assets/images/logos/logoblue.svg";
import "./styles/ToggleButton.scss";

const Nav = styled.div`
  height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: black;
`;

const NavIcon = styled(Link)`
  font-size: 2rem;
  height: 80px;
  display: flex;
  padding-left: 2.5rem;
  justify-content: flex-start;
  align-items: center;
  color: black;
`;

const SidebarNav = styled.nav`
  padding-top: 30px;
  background-color: white;
  color: black;
  width: 350px;
  height: 100%;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  //  left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
  transform: translateX(${({ sidebar }) => (sidebar ? "0" : "-100%")});
  transition: transform 0.5s ease-out;
  // transition: 700ms;
  z-index: 1000;
`;

const SidebarWrap = styled.div`
  width: 100%;
`;

const Sidebar = () => {
  const [sidebar, setSidebar] = useState(false);
  const [backdrop, setBackdrop] = useState(false);
  const [color, setColor] = useState(false);

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const nav = document.getElementsByClassName(".toggle-button");
    const navHeight = nav.scrollHeight;

    const handleScroll = () => {
      const scrollHeight = window.pageYOffset;
      setIsSticky(scrollHeight > navHeight ? true : false);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const changeColor = () => {
    if (window.scrollY >= 200) {
      setColor(true);
    } else {
      setColor(false);
    }
  };

  window.addEventListener("scroll", changeColor);
  const showSidebar = () => {
    setSidebar(!sidebar);
  };
  const wrapperRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setSidebar(sidebar);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);
  function handleBackdrop() {
    setBackdrop(true);
  }

  return (
    <div className="main-div">
      <IconContext.Provider value={{ color: "#fff" }}>
        <Nav>
          <NavIcon to="/"></NavIcon>
          <FaIcons.FaBars
            className={color ? "toggle-button active" : "toggle-button"}
            onClick={() => {
              showSidebar();
              handleBackdrop();
            }}
          />
        </Nav>

        <SidebarNav className="side-wrapper" sidebar={sidebar} ref={wrapperRef}>
          <SidebarWrap>
            <NavIcon className="mobile-top" to="/">
              <img src={logo} className="logo-side-img" alt="hostai logo" />
              <AiIcons.AiOutlineClose
                className="close-side-btn"
                onClick={() => {
                  showSidebar();
                  setBackdrop(false);
                }}
              />
            </NavIcon>
            {SidebarData.map((item, index) => {
              return <SubMenu item={item} key={index} />;
            })}
            <div className="buttons">
              <Link to="/login">
                <button className="login btn">Log In</button>
              </Link>
              <Link to="/signup">
                <button className="signup btn">Sign Up</button>
              </Link>
            </div>
          </SidebarWrap>
        </SidebarNav>
        <Backdrop trigger={backdrop} setTrigger={setBackdrop} />
      </IconContext.Provider>
    </div>
  );
};

export default Sidebar;
